const observablesToData = (models) => {
  const op = {};
  Object.keys(models).forEach((key) => {
    op[key] =
      models[key] && models[key].data ? models[key].data() : models[key];
  });
  return op;
};
const observableToUseEffect = (observables = {}, updateMethod) => {
  const initialState = observablesToData(observables);
  setTimeout(() => {
    updateMethod(initialState);
  });
  const subscriptions = [];
  Object.keys(observables).forEach((model) => {
    if (observables[model] && observables[model].observable) {
      subscriptions.push(
        observables[model].observable().subscribe((data) => {
          updateMethod(observablesToData(observables));
        })
      );
    }
  });

  return () => {
    while (subscriptions.length) {
      subscriptions.shift().unsubscribe();
    }
  };
};

export default observableToUseEffect;
